import { useEffect, useState } from "react";
import { Alert, Button } from "@mui/material";
import { useTranslation } from "i18n-fe";
import { getStorageFailure, subscribeStorageFailure } from "../local/storageFailure";

// Card #3257 (AC2). db.js reports every QuotaExceededError on an outbox or
// scoreSheets write to local/storageFailure.js (and rethrows). This is the one
// place the scribe is told: a write the device refused means the last edit may
// not be saved, which must never be silent. No dismiss button (kiosk doctrine):
// it clears itself the next time that kind of write succeeds.
export default function StorageFullBanner() {
  const { t } = useTranslation("score");
  const [failure, setFailure] = useState(() => getStorageFailure());

  useEffect(() => {
    setFailure(getStorageFailure());
    return subscribeStorageFailure(setFailure);
  }, []);

  if (!failure) return null;

  // Card #3257 AC5: a blocked / stale IndexedDB connection needs a reload.
  const needsReload = failure.kind === "blocked" || failure.kind === "stale";
  const message = failure.kind === "blocked"
    ? t("status.dbBlocked")
    : failure.kind === "stale"
      ? t("status.dbStale")
      : t("status.storageFull");

  return (
    <Alert
      data-testid="storage-full-banner"
      severity="error"
      variant="filled"
      role="alert"
      sx={{ borderRadius: 0, position: "sticky", top: 0, zIndex: (theme) => theme.zIndex.appBar + 1 }}
      action={
        needsReload ? (
          <Button color="inherit" size="small" onClick={() => window.location.reload()}>
            {t("status.reload")}
          </Button>
        ) : undefined
      }
    >
      {message}
    </Alert>
  );
}
